import React, { useContext } from "react"
import { Navigate } from "react-router-dom"
import { pagesUrl } from "@app/core/appConstants"
import { OrganizationContext } from "@app/core/context/organization/OrganizationContext"

type IProps = {
  children: React.JSX.Element | null
}

/**
 * US 2620 — the page of the INIES changes opened by a member of an organization without the option (a bookmark, a
 * shared link) goes back home. Only once the organization is known.
 */
export default function RequireIniesChangesOption({ children }: IProps): React.JSX.Element | null {
  const { organization } = useContext(OrganizationContext)
  if (organization && !organization.iniesChangesOption) {
    return <Navigate to={pagesUrl.HOME} replace />
  }
  return children
}
